import {
  type CompletedFixOutcome,
  type CompletedScaOutcome,
  type CompletedTriageOutcome,
} from './api-client/api-schemas.ts'

/**
 * Determines whether a triage outcome should show confetti.
 * Success outcomes: false_positive, wont_fix
 */
export const shouldShowTriageConfetti = (outcome?: CompletedTriageOutcome) => {
  if (!outcome) return false
  return outcome.suggested_status === 'false_positive' || outcome.suggested_status === 'wont_fix'
}

/**
 * Determines whether a fix outcome should show confetti.
 * Success outcomes: preview available (has description), no fix necessary (no description)
 */
export const shouldShowFixConfetti = (outcome?: CompletedFixOutcome) => {
  if (!outcome) return false
  return true
}

/**
 * Determines whether an SCA outcome should show confetti.
 * Success outcome: not-exploitable
 */
export const shouldShowScaConfetti = (outcome?: CompletedScaOutcome) => {
  if (!outcome) return false
  return outcome.classification === 'not-exploitable'
}
